import { render, staticRenderFns } from "./LabelCanvas.vue?vue&type=template&id=878aeb10&scoped=true&"
import script from "./LabelCanvas.vue?vue&type=script&lang=js&"
export * from "./LabelCanvas.vue?vue&type=script&lang=js&"
import style0 from "./LabelCanvas.vue?vue&type=style&index=0&id=878aeb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878aeb10",
  null
  
)

export default component.exports